import WebSocketProvider from './websocketProvider';
// import onlineService from './onlineService';
import {CONFIG} from './config';
import { IcommunicationObj } from './interfaces';

export default class CommunicationWrp {

  private connType = 'websocket';
  private chatURL = '';
  private connID = 1;
  private ws: any;
  private offline: any;
  private chatCB: any;

  constructor (callback: any, chatURL: string) {
    this.chatCB = callback;
    this.chatURL = chatURL;
  }

  public connect(): void {
    this.connectWS();
    /*if (onlineService.isOnline())
      this.connectWS();
    else
      this.connectOffline();*/
  }

  /*private connectOffline(): void {
    this.offline = new offlineProvider(this.connID);
    this.offline.connect(this.messageCB);
  }*/

  private connectWS(): void {
    // this.ws = new atmosphereProvider(this.connID, this.chatURL, this.connType);
    this.ws = new WebSocketProvider(this.connID, this.chatURL);
    this.ws.connect(this.messageCB);
  }

  public disconnect(): void {
    this.ws.unsubscribe();
  }

  public sendMess(msg: any): void {
    this.ws.push(msg);
  }

  //callback from atmosphere/offline provider
  public messageCB = (messObj: IcommunicationObj): void => {
    // log.info('communicationWrp:', messObj);
    this.chatCB(messObj);
  }

}
